import Vuex from 'vuex';
import Vue from 'vue';
import Gikam from '../../../core/gikam-core';

Vue.use(Vuex);

class GridStore {

    constructor(options, grid) {
        this.options = options;
        this.grid = grid;
        this.initStore();
    }

    refreshGrid(data) {
        this.grid.refresh(data);
    }

    initStore() {
        const _this = this;
        this.store = new Vuex.Store({
            state: {
                requestData: this.options.requestData,
                fieldTypeMapper: null,
                columns: this.getColumns(),
                gridId: this.options.id,
                $window: this.grid.$window,
                pageNum: this.options.pageNum,
                pageSize: this.options.pageSize,
                page: this.options.page,
                pageList: this.options.pageList,
                totalRecord: 0
            },
            getters: {
                totalPage(state) {
                    return Math.ceil(state.totalRecord / state.pageSize) || 1
                }
            },
            mutations: {
                refresh(_state, data) {
                    _this.refreshGrid(data);
                },
                refreshColumns(state, columns) {
                    state.columns = columns;
                },
                updatePageSize(state, pageSize) {
                    state.pageSize = pageSize;
                    state.pageNum = 1;
                    _this.refreshGrid();
                },
                updatePageNum(state, pageNum) {
                    if (pageNum > this.getters.totalPage) {
                        state.pageNum = this.getters.totalPage;
                        return;
                    }
                    if (pageNum < 1 || isNaN(parseInt(pageNum))) {
                        state.pageNum = 1;
                        return;
                    }
                    state.pageNum = pageNum;
                    _this.refreshGrid();
                },
                updateTotalRecord(state, totalRecord) {
                    state.totalRecord = totalRecord;
                },
            }
        });
    }

    /**
     * @description 获取表格列，优先从配置文件中获取
     * @memberof Grid
     * @returns Array
     */
    getColumns() {
        const manager = Gikam.compConfigManager;
        const columns = this.options.columns;
        const gridId = this.grid.options.id;
        if (manager.grid && manager.grid[gridId]) {
            let settingColumns = manager.grid[gridId].columns;
            return columns.filter(item => item.checkbox || item.index)
                .concat(settingColumns.map(column => {
                    let initColumn = columns.filter(item => item.field == column.field);
                    return Gikam.deepExtend(initColumn[0], column);
                }));
        }
        return columns;
    }
}

export { GridStore }